module.exports = __webpack_public_path__ + "static/media/rectangle-view-on.e8ec6bc2.svg";